import { useQuery } from '@tanstack/react-query';

import { medusaClient } from '@/services/apiClient';
import { isDateInRangeOfMonth } from '@/utils/functions';
import { OmnibusPrice } from '@/utils/types/api';

export const useOmnibusPrice = (id: string) => {
  const query = useQuery(['omnibus-price'], async () => {
    const response = await medusaClient.get<OmnibusPrice>(
      `store/omnibus-price`,
      {
        params: {
          productId: id,
        },
      },
    );

    if (!isDateInRangeOfMonth(response.data.created_at)) {
      return null;
    }

    return response.data;
  });

  const { data: omnibusPrice, ...other } = query;

  return { omnibusPrice, ...other };
};
